<script>
const badgeMap = {
    'admin': 'badge-dark',
    'team': 'badge-success',
    'staff': 'badge-danger',
    'editor': 'badge-primary',
    'editor-assistant': 'badge-info',
    'service-provider': 'badge-warning',
};

export default {
    name: 'RoleBadge',

    functional: true,

    props: {
        role: {type: Object, required: true},
    },

    render(createElement, {props, data, parent}) {
        const description = parent.$t(`roles.shortname.${props.role.name}`);

        if (description) {
            const badgeClass = badgeMap[props.role.name];

            data.staticClass = [data.staticClass, 'badge', badgeClass].join(' ');

            return createElement('span', data, [description]);
        }

        return null;
    },
};
</script>
